import React, { useContext } from 'react';

// Components
import MessagesInboxFake from './MessagesInboxFake';
import MessagesInboxReady from './MessagesInboxReady';
import NewConversationMemberSearch from './NewConversationMemberSearch';
import Alert from '@atoms/Alert';
import LoadingArea from '@molecules/LoadingArea';

// Functionality
import InboxReadyProvider from './providers/InboxReadyProvider';
import { ConversationsContext } from '../../../context/ConversationsProvider';
import { ConversationsClientContext } from '../../../context/ConversationsClientProvider';
import { MessagingTokenContext } from '../../../context/MessagingTokenProvider';
import { ChatUserContext } from '../../../context/ChatUserProvider';

const MessagesInbox = () => {
    const { doesChatUserExist } = useContext(ChatUserContext);
    const { conversations } = useContext(ConversationsContext);
    const { status } = useContext(ConversationsClientContext);
    const { error } = useContext(MessagingTokenContext);

    if (error || status === 'error') {
        return <Alert status="danger" msg="There was a problem connecting to messaging." />;
    }

    if (doesChatUserExist === false) {
        return <MessagesInboxFake />;
    }

    if (doesChatUserExist === null || !conversations) {
        return <LoadingArea minHeight={620} />;
    }

    return (
        <>
            {/* {conversations && conversations.length === 30 && (
                <Alert status="warning" msg="You have reached the limit of 30 conversations." />
            )} */}
            {/* <NewConversationMemberSearch /> */}
            <InboxReadyProvider>
                <MessagesInboxReady />
            </InboxReadyProvider>
        </>
    );
};

export default MessagesInbox;
